export const SHORTLIST_STORAGE_KEY = 'shortlist';
export const SHORTLIST_PERSISTED_VERSION = 1;
export const MAX_SHORTLIST_SIZE = 9;
export const MIN_PREVIEW_AVATARS = 3;
export const MAX_PREVIEW_AVATARS = 5;

export const MULTI_CONTACT_ROUTE = '/multi-contact-sitter/';

/**
 * DOM mount node (in the Django header) for ShortListModal.
 */
export const SHORTLIST_MODAL_SELECTOR = '#react-shortlist-modal';

/**
 * Window event dispatched by the non-React navbar button to open the modal.
 * Bridges legacy (Django/Backbone) pages to ShortListModal.
 */
export const SHORTLIST_MODAL_OPEN_EVENT = 'rover:shortlist:open';
